export enum InventoryProjectionStatus {
  Covered = "covered",
  CoveredByInbound = "covered_by_inbound",
  Short = "short",
}
